import { Colors, Icon } from '@blueprintjs/core'
import { IconNames } from '@blueprintjs/icons'
import * as React from 'react'
import { UprightStyle } from '../../types'
import { buildPublicResourceUrl } from '../../utils/images'

interface Props {
  name?: string
  humanReadableName?: string
  size?: number
}

const DEFAULT_SIZE = 30

const style: UprightStyle = {
  chipContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    overflow: 'hidden'
  },
  fill: { width: '100%', height: '100%' }
}

export const LogoChip: React.FC<Props> = props => {
  const size = props.size || DEFAULT_SIZE
  const small = size < 200
  const suffix = small ? '-sm.png' : '.png'

  const imagePath = `/logos/${props.name?.toLowerCase() || ''}-square${suffix}`

  const chipStyleWithDimensions = React.useMemo(
    () => ({
      ...style.chipContainer,
      minWidth: size,
      width: size,
      height: size
    }),
    [size]
  )
  return (
    <div className="logo-chip" style={chipStyleWithDimensions}>
      {props.name && (
        <img
          alt="carrier-icon"
          title={props.humanReadableName || props.name}
          style={style.fill}
          src={buildPublicResourceUrl(imagePath)}
        />
      )}
      {!props.name && <Icon icon={IconNames.ENVELOPE} size={props.size} color={Colors.GRAY3} />}
    </div>
  )
}
